import React, { useState, useEffect, useRef } from "react";
import Icon from "../Icon/Icon";
import print from "../../svgs/print.svg"
import styles from "./SplitButton.scss"; 

const SplitButton = ({icon = false, options = [], onChange, selectedOption, onClick}) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Calculate dynamic width based on the longest option
  const getMaxWidth = () => {
    const longestOption = options.reduce((max, option) =>
      option.length > max.length ? option : max, "");
    return longestOption.length * 10 + 20; // Approximate width per character
  };

  const buttonWidth = `${getMaxWidth()}px`;

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    onChange(option); // Update button label
    setIsOpen(false); // Close dropdown
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={"split-button-container"}>
      <button
        className={`split-button main-button`}
        style={{ width: buttonWidth }}
        onClick={onClick}
      >
        <span className="title-container">{selectedOption} {/* Button label updates based on selection */}{icon&&<Icon svg={print}/>}</span>
      </button>
      <button
        className={`split-button toggle-button`}
        onClick={toggleDropdown}
      >
        {isOpen ? "▲" : "▼"}
      </button>

      {isOpen && (
        <ul
        className={'dropdown'} style={{ minWidth: buttonWidth }}
        >
          {options.map((option) => (
            <li
              key={option}
              className={`dropdown-item ${
                selectedOption === option ? styles.selected : ""
              }`}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SplitButton;
